import styled, { css } from 'styled-components';

const transitionTiming = '0.2s';

export const RadioButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  border: 2px solid ${({ theme }) => theme.COLOR_GRAY_LIGHT};
  border-radius: 4px;
  cursor: pointer;
  padding-left: 1.125rem;
  transition: background-color ${transitionTiming}, border-color ${transitionTiming};

  ${({ theme }) => `
    &:hover {
      border-color: ${theme.COLOR_GRAY_DARK};
    }
  `}

  ${({ isSelected, theme }) => isSelected && css`
    background-color: ${theme.COLOR_AQUA_ALPHA};
    border-color: ${theme.COLOR_CYAN_DARK};
  `}

  ${({ isErrored, theme }) => isErrored && css`
    background-color: ${theme.COLOR_LIGHT_RED};
    border-color: ${theme.COLOR_CYAN_DARK};
  `}

  ${({ isHighlighted, theme }) => isHighlighted && css`
    border-color: ${theme.COLOR_CYAN_DARK};
  `}
`;

/**
 * Idea for showing selected state is to change the BG colour to green, as there's an inset box
 * shadow below which handles the white gap between circle and border. ALternative to this was
 * to use a pseudo-element but at these small sizes it looks off-centred on higher-res screens.
 */
export const RadioButtonIndicator = styled.div`
  width: 25px;
  height: 25px;
  border: 2px solid ${({ theme }) => theme.COLOR_CYAN_DARK};
  background: ${({ isSelected, theme }) => (isSelected ? theme.COLOR_CYAN_DARK : theme.COLOR_WHITE)};
  box-shadow: inset 0px 0px 0px 3px ${({ theme }) => theme.COLOR_WHITE};
  border-radius: 50%;
  margin-right: 1rem;
  transition: background ${transitionTiming};
  flex-shrink: 0;
`;

export const RadioButtonContent = styled.div`
  flex-grow: 1;
`;
